var map = {
	"./de/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/de/catalog.json",
		7
	],
	"./en/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/en/catalog.json",
		8
	],
	"./es-AR/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/es-AR/catalog.json",
		9
	],
	"./es/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/es/catalog.json",
		10
	],
	"./fr/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/fr/catalog.json",
		11
	],
	"./he/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/he/catalog.json",
		12
	],
	"./it/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/it/catalog.json",
		13
	],
	"./ja/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/ja/catalog.json",
		14
	],
	"./ko/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/ko/catalog.json",
		15
	],
	"./ro/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/ro/catalog.json",
		16
	],
	"./ru/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/ru/catalog.json",
		17
	],
	"./vi/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/vi/catalog.json",
		18
	],
	"./zh-CN/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/zh-CN/catalog.json",
		19
	],
	"./zh-TW/catalog.json": [
		"./node_modules/@lingui/loader/index.js!./src/language/locales/zh-TW/catalog.json",
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/language/locales lazy recursive ./node_modules/@lingui/loader/index.js!./ ^\\.\\/.*\\/catalog\\.json$";
module.exports = webpackAsyncContext;